(function ($) {
    $(document).on('click', '.btn-share', function (e) {
        e.preventDefault();
        const windowUrl = window.location.href;
        const dummyClipboard = document.createElement('input');
        dummyClipboard.setAttribute('id','clipboard');
        const $this = $(this);

        if (navigator.share) {
            navigator.share({
                title: $this.attr('aria-label'),
                url: windowUrl
            });
        } else {
            document.body.appendChild(dummyClipboard);
            dummyClipboard.value = windowUrl;
            dummyClipboard.select();
            document.execCommand('copy');
            document.body.removeChild(dummyClipboard);
            $this.addClass('tooltip');
            setTimeout(() => {
                $this.removeClass('tooltip')
            }, "3000");
        }
    });
})(jQuery);